import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';

const SCHEMA_TREINAMENTOS = JSON.stringify({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL}/treinamentos#webpage`,
      url: `${import.meta.env.VITE_SITE_URL}/treinamentos`,
      name: 'Treinamentos de Segurança do Trabalho Sorocaba Campinas | NRs — Engeporto',
      description: 'Treinamentos NR-06, NR-10, NR-12, NR-17, NR-20, NR-23, NR-33, NR-35, Brigada de Incêndio e Primeiros Socorros em Sorocaba e Campinas.',
      inLanguage: 'pt-BR',
      isPartOf: { '@id': `${import.meta.env.VITE_SITE_URL}/#website` },
    },
    {
      '@type': 'Service',
      name: 'Treinamentos Técnicos em Segurança do Trabalho',
      provider: {
        '@type': 'LocalBusiness',
        name: 'Engeporto Engenharia e Serviços Ltda.',
        url: import.meta.env.VITE_SITE_URL,
      },
      areaServed: ['Sorocaba', 'Campinas', 'Porto Feliz'],
      serviceType: 'Treinamentos NRs e Brigada de Incêndio',
      url: `${import.meta.env.VITE_SITE_URL}/treinamentos`,
    },
  ],
});

const treinamentos = [
  {
    icon: 'ri-shield-check-line',
    title: 'NR-06: Equipamentos de Proteção Individual',
    nivel: 'Conscientização e Uso Correto',
    cargaHoraria: '4h',
    modalidade: 'Presencial ou Online',
    publicoAlvo: 'Todos os colaboradores que utilizam EPIs',
    descricao: 'Treinamento sobre seleção, uso correto, conservação e limitações dos Equipamentos de Proteção Individual, conforme obrigações legais da NR-06.',
    color: 'from-teal-500 to-cyan-600'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'NR-10: Segurança em Instalações Elétricas',
    nivel: 'Básico e Complementar',
    cargaHoraria: '40h (Básico) / 40h (Complementar)',
    modalidade: 'Presencial',
    publicoAlvo: 'Eletricistas e profissionais que trabalham com eletricidade',
    descricao: 'Treinamento obrigatório para trabalhos em instalações elétricas, abordando riscos, medidas de proteção e procedimentos de segurança.',
    color: 'from-yellow-500 to-amber-500'
  },
  {
    icon: 'ri-settings-3-line',
    title: 'NR-12: Máquinas e Equipamentos',
    nivel: 'Operação Segura',
    cargaHoraria: '8h',
    modalidade: 'Presencial',
    publicoAlvo: 'Operadores de máquinas e equipamentos',
    descricao: 'Treinamento sobre operação segura, dispositivos de proteção, manutenção preventiva e procedimentos de bloqueio.',
    color: 'from-gray-600 to-gray-800'
  },
  {
    icon: 'ri-user-heart-line',
    title: 'NR-17: Ergonomia',
    nivel: 'Conscientização',
    cargaHoraria: '4h',
    modalidade: 'Presencial ou Online',
    publicoAlvo: 'Todos os colaboradores',
    descricao: 'Orientações sobre postura correta, organização do trabalho, pausas e prevenção de lesões por esforço repetitivo.',
    color: 'from-green-500 to-emerald-500'
  },
  {
    icon: 'ri-oil-line',
    title: 'NR-20: Inflamáveis e Combustíveis',
    nivel: 'Básico, Intermediário e Avançado',
    cargaHoraria: '4h / 8h / 16h',
    modalidade: 'Presencial',
    publicoAlvo: 'Trabalhadores que operam com inflamáveis',
    descricao: 'Capacitação sobre armazenamento, manuseio e transporte de líquidos inflamáveis e combustíveis com segurança.',
    color: 'from-orange-500 to-red-500'
  },
  {
    icon: 'ri-fire-fill',
    title: 'NR-23: Proteção Contra Incêndio',
    nivel: 'Básico',
    cargaHoraria: '4h',
    modalidade: 'Presencial',
    publicoAlvo: 'Todos os colaboradores e responsáveis pela segurança',
    descricao: 'Capacitação sobre medidas de prevenção e proteção contra incêndio, uso de extintores, rotas de fuga, sinalização de emergência e plano de evacuação.',
    color: 'from-red-600 to-rose-700'
  },
  {
    icon: 'ri-door-closed-line',
    title: 'NR-33: Espaço Confinado',
    nivel: 'Trabalhadores e Vigias',
    cargaHoraria: '16h (Formação) / 8h (Reciclagem)',
    modalidade: 'Presencial',
    publicoAlvo: 'Trabalhadores autorizados e vigias de espaços confinados',
    descricao: 'Treinamento sobre identificação de espaços confinados, riscos atmosféricos, procedimentos de entrada e resgate.',
    color: 'from-purple-500 to-indigo-500'
  },
  {
    icon: 'ri-building-line',
    title: 'NR-35: Trabalho em Altura',
    nivel: 'Capacitação',
    cargaHoraria: '8h',
    modalidade: 'Presencial',
    publicoAlvo: 'Trabalhadores que executam atividades acima de 2 metros',
    descricao: 'Capacitação obrigatória sobre análise de risco, uso de EPIs, sistemas de proteção contra quedas e procedimentos de emergência.',
    color: 'from-blue-500 to-cyan-500'
  },
  {
    icon: 'ri-fire-line',
    title: 'Brigada de Incêndio',
    nivel: 'Básico e Intermediário',
    cargaHoraria: '4h (Básico) / 8h (Intermediário)',
    modalidade: 'Presencial',
    publicoAlvo: 'Brigadistas e colaboradores designados',
    descricao: 'Capacitação completa para prevenção e combate a princípios de incêndio, evacuação de áreas e primeiros socorros básicos.',
    color: 'from-red-500 to-orange-500'
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Primeiros Socorros',
    nivel: 'Básico',
    cargaHoraria: '3h',
    modalidade: 'Presencial',
    publicoAlvo: 'Brigadistas e colaboradores interessados',
    descricao: 'Capacitação em técnicas de primeiros socorros, RCP, uso de DEA e atendimento a emergências médicas.',
    color: 'from-pink-500 to-rose-500'
  },
];

const diferenciais = [
  {
    icon: 'ri-user-star-line',
    title: 'Instrutores Especializados',
    descricao: 'Engenheiros e profissionais com vasta experiência prática e certificações reconhecidas'
  },
  {
    icon: 'ri-award-line',
    title: 'Certificado Reconhecido',
    descricao: 'Certificados válidos em todo território nacional, conforme legislação vigente'
  },
  {
    icon: 'ri-book-open-line',
    title: 'Material Didático Completo',
    descricao: 'Apostilas atualizadas, apresentações e materiais de apoio para consulta posterior'
  },
  {
    icon: 'ri-building-2-line',
    title: 'Treinamento In Company',
    descricao: 'Realizamos treinamentos na sua empresa, adequando horários e conteúdo às suas necessidades'
  }
];

const metodologia = [
  {
    numero: '01',
    titulo: 'Teoria Fundamentada',
    descricao: 'Base conceitual sólida com legislação, normas técnicas e melhores práticas do mercado'
  },
  {
    numero: '02',
    titulo: 'Prática Supervisionada',
    descricao: 'Exercícios práticos com equipamentos reais e simulações de situações de risco'
  },
  {
    numero: '03',
    titulo: 'Simulações Realistas',
    descricao: 'Cenários que reproduzem condições reais de trabalho para melhor fixação do aprendizado'
  },
  {
    numero: '04',
    titulo: 'Avaliação e Certificação',
    descricao: 'Avaliação teórica e prática para garantir a competência dos participantes'
  }
];

export default function TreinamentosPage() {
  useEffect(() => {
    document.title = 'Treinamentos de Segurança do Trabalho Sorocaba Campinas | NRs — Engeporto';
    const setMeta = (name: string, content: string, prop = false) => {
      const sel = prop ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      const el = document.querySelector(sel) as HTMLMetaElement | null;
      if (el) el.setAttribute('content', content);
    };
    setMeta('description', 'Treinamentos NR-06, NR-10, NR-12, NR-17, NR-20, NR-23, NR-33, NR-35, Brigada de Incêndio e Primeiros Socorros nas Regiões Metropolitanas de Sorocaba e Campinas. Engeporto Engenharia.');
    setMeta('keywords', 'treinamento NR-10 Sorocaba, NR-35 Campinas, brigada incêndio, NR-33, NR-23, capacitação segurança trabalho');
    setMeta('og:title', 'Treinamentos de Segurança do Trabalho | NRs — Engeporto Sorocaba Campinas', true);
    setMeta('og:description', 'Treinamentos NRs, Brigada de Incêndio e Primeiros Socorros em Sorocaba e Campinas.', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL}/treinamentos`, true);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/treinamentos`);
    return () => { canonical?.remove(); };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: SCHEMA_TREINAMENTOS }}
      />
      <Navbar />
      
      {/* Header Premium */}
      <section className="relative bg-gradient-to-br from-[#0A1628] via-[#0F2847] to-[#0A1628] text-white pt-40 pb-16 md:pt-40 md:pb-32 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
            backgroundSize: '30px 30px'
          }}></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto text-center"
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.6 }}
              className="inline-block mb-6"
            >
              <span className="inline-flex items-center gap-2 px-6 py-2 bg-[#D4AF37]/20 border border-[#D4AF37]/30 rounded-full text-[#D4AF37] text-sm font-medium">
                <i className="ri-graduation-cap-line text-lg"></i>
                Capacitação Profissional
              </span>
            </motion.div>
            
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Treinamentos Técnicos
            </h1>
            <p className="text-sm md:text-xl text-gray-300 leading-relaxed">
              Capacitação especializada em segurança do trabalho e prevenção de incêndio com instrutores qualificados e certificados reconhecidos
            </p>
          </motion.div>
        </div>
      </section>

      {/* Grid de Treinamentos */}
      <section className="py-24 bg-neutral-50">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <span className="inline-block px-4 py-2 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-sm font-semibold mb-4">
              Nossos Treinamentos
            </span>
            <h2 className="text-4xl font-bold text-[#0A1628] mb-4">
              Cursos e Capacitações Oferecidos
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Treinamentos práticos e teóricos que atendem às exigências das Normas Regulamentadoras e legislação vigente
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-8">
            {treinamentos.map((treinamento, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                whileHover={{ y: -8 }}
                className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                <div className={`h-2 bg-gradient-to-r ${treinamento.color}`}></div>
                
                <div className="p-5 md:p-8">
                  <div className={`w-12 h-12 md:w-16 md:h-16 rounded-2xl bg-gradient-to-br ${treinamento.color} flex items-center justify-center mb-4 md:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    <i className={`${treinamento.icon} text-2xl md:text-3xl text-white`}></i>
                  </div>
                  
                  <h3 className="text-lg md:text-2xl font-bold text-[#0A1628] mb-2">
                    {treinamento.title}
                  </h3>
                  
                  <span className="inline-block px-3 py-1 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-xs font-semibold mb-3 md:mb-4">
                    {treinamento.nivel}
                  </span>
                  
                  <div className="space-y-2 md:space-y-3 mb-4 md:mb-6">
                    <div className="flex items-center gap-2 text-gray-600">
                      <i className="ri-time-line text-[#D4AF37]"></i>
                      <span className="text-sm">{treinamento.cargaHoraria}</span>
                    </div>
                    <div className="flex items-center gap-2 text-gray-600">
                      <i className="ri-map-pin-line text-[#D4AF37]"></i>
                      <span className="text-sm">{treinamento.modalidade}</span>
                    </div>
                    <div className="flex items-start gap-2 text-gray-600">
                      <i className="ri-user-line text-[#D4AF37] mt-1"></i>
                      <span className="text-sm">{treinamento.publicoAlvo}</span>
                    </div>
                  </div>
                  
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 md:mb-6">
                    {treinamento.descricao}
                  </p>
                  
                  <a
                    href={`https://wa.me/5515996719308?text=${encodeURIComponent('Olá! Vim pela página de Treinamentos e gostaria de solicitar um orçamento.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-[#D4AF37] text-sm md:text-base font-semibold hover:gap-3 transition-all duration-300 whitespace-nowrap"
                  >
                    Solicitar Orçamento
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-12 md:py-24 bg-white">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <span className="inline-block px-4 py-2 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-sm font-semibold mb-4">
              Por Que Escolher a Engeporto
            </span>
            <h2 className="text-4xl font-bold text-[#0A1628] mb-4">
              Diferenciais dos Nossos Treinamentos
            </h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {diferenciais.map((diferencial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="text-center"
              >
                <div className="w-14 h-14 md:w-20 md:h-20 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center mx-auto mb-6">
                  <i className={`${diferencial.icon} text-3xl md:text-4xl text-[#D4AF37]`}></i>
                </div>
                <h3 className="text-base md:text-xl font-bold text-[#0A1628] mb-3">
                  {diferencial.title}
                </h3>
                <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                  {diferencial.descricao}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Metodologia */}
      <section className="py-12 md:py-24 bg-neutral-50">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <span className="inline-block px-4 py-2 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-sm font-semibold mb-4">
              Nossa Metodologia
            </span>
            <h2 className="text-4xl font-bold text-[#0A1628] mb-4">
              Como Funcionam Nossos Treinamentos
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Metodologia comprovada que combina teoria, prática e simulações para garantir o aprendizado efetivo
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {metodologia.map((etapa, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1, duration: 0.6 }}
                className="relative"
              >
                <div className="bg-white rounded-3xl p-5 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 h-full">
                  <div className="text-4xl md:text-6xl font-bold text-[#D4AF37]/20 mb-4">
                    {etapa.numero}
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-[#0A1628] mb-3">
                    {etapa.titulo}
                  </h3>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                    {etapa.descricao}
                  </p>
                </div>
                
                {index < metodologia.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-3xl text-[#D4AF37]/30"></i>
                  </div>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="relative py-14 md:py-24 bg-gradient-to-br from-[#0A1628] via-[#0F2847] to-[#0A1628] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
            backgroundSize: '30px 30px'
          }}></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold mb-6">
              Capacite Sua Equipe com Treinamentos de Excelência
            </h2>
            <p className="text-base md:text-xl text-gray-300 mb-10 leading-relaxed">
              Entre em contato e solicite um orçamento personalizado para os treinamentos da sua empresa
            </p>
            <a
              href={`https://wa.me/5515996719308?text=${encodeURIComponent('Olá! Vim pela página de Treinamentos e gostaria de capacitar minha equipe. Pode me enviar um orçamento?')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-6 py-4 md:px-10 md:py-5 bg-[#D4AF37] text-[#0A1628] rounded-full font-bold text-base md:text-lg hover:bg-[#C4A137] hover:scale-105 transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
              Solicitar Treinamento
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
      <ScrollToTopButton />
    </div>
  );
}